/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Download: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="download" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M419.2987666666667 613.53L708.3276666666667 365.7890000000001L997.356 613.53L948.1863333333334 670.8936666666667L746.1073333333334 497.6863333333333V1171.1016666666667H670.5536666666666L670.5536666666666 497.6863333333333L468.4695666666667 670.8936666666667L419.2987666666667 613.53zM217.2175 264.435H1199.4406666666666V188.8813333333335H217.2175V264.435z" : "M335.4390133333334 490.824L566.6621333333334 292.6312000000001L797.8848 490.824L758.5490666666668 536.7149333333333L596.8858666666667 398.1490666666666V936.8813333333331H536.4429333333334L536.4429333333334 398.1490666666666L374.7756533333334 536.7149333333333L335.4390133333334 490.824zM173.774 211.5479999999999H959.5525333333334V151.1050666666666H173.774V211.5479999999999z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Download.displayName = `Blueprint5.Icon.Download`;
export default Download;
